import React from "react"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import Divider from "@mui/material/Divider"
import SimpleBar from "simplebar-react"
import CreateIcon from '@mui/icons-material/Create';

import Checkbox from '@mui/material/Checkbox'

import {useTranslation} from "react-i18next"

import CircleInfo from "app/components/shared/CircleInfo/CircleInfo"
import AddAbilityElement from "app/components/Abilities/AddAbilityElement/AddAbilityElement"

import useStore from 'app/store/store'

import 'simplebar-react/dist/simplebar.min.css';
import './KnlgCmpnts.scss'


export default function KnlgCmpnts({ability, disabledPanel, srcScrollRef, destScrollRef, preSelectedElm, typeFor}){

  const {t} = useTranslation();
  const fillingAbilitiesStep = useStore((state) => state.fillingAbilitiesStep);
  const isFillingNewElm = useStore((state) => state.isFillingNewElm);
  const storeActions = useStore((state) => state.actions);

  const course = useStore((state) => state.course);

  const courseElmComponents = useStore((state) => state.courseElmComponents);
  const currentKnlgElmId = useStore((state) => state.currentKnlgElmId);

  storeActions.setMutualScrollEvent(srcScrollRef, destScrollRef);


  return (
    <Box className="knlg-cmpnts-list-cover ">
      <Grid container>
        <div className="v-space-4"></div> 
        <Grid item xs={12} className="d-f jc-c ">
          <Typography variant="span"  onClick={()=>storeActions.setKnowledgeComponentOpen(true)}  className={"font-1 big-title fourth-color pointer" }>
            {t("COMPONENTS")} <CreateIcon sx={{fontSize: 28}} />
          </Typography>
         
        </Grid>
        <Grid item xs={12} className="d-f jc-c ab-title-hight">
          <Typography variant="span" className={"font-2 sub-title center-text fourth-color"} >
            {t("Select the components of knowledge relevant for this course")}
          </Typography>
        </Grid>
        <Grid item xs={12} className="d-f jc-c turncate">
          <Typography variant="span" className="font-2 second-color-faded-3 sub-title">
            {t("In this course students will learn")}
          </Typography>
        </Grid>
        <div className="v-space-4"></div>

        {
          (isFillingNewElm && typeFor === fillingAbilitiesStep ) && <AddAbilityElement />
        }
        
        {
          !(isFillingNewElm && typeFor === fillingAbilitiesStep ) && 
          <>
            <Grid container className="d-f jc-sb ai-c row-hight" item xs={12}>
              <Grid item xs={2}>
                <CircleInfo numbering={"?"} text={t("Relevant")} />
              </Grid>
              
            </Grid>
            <Divider light className="w-100"/>
            <SimpleBar scrollableNodeProps={{ref: srcScrollRef}}  className="scroll-component-exp" >
              <Grid item xs={12} sx={{paddingRight:1}}>
                {
                  (course.knowledge_components.map((elm, key)=> {

                    let cFound = courseElmComponents.find((elmComp) => (elmComp.knowledge_component_id === elm.id && elmComp.elm_type === typeFor && elmComp.elm_id === currentKnlgElmId));


                    return (
                      <Box key={key} className={"row-hight auto "+(preSelectedElm===elm.id? 'bg-second-color-faded-2': '')}>
                        
                        <Grid container >

                          <Grid item xs={2} className="d-f jc-c ai-t" sx={{marginTop: '7px'}}>
                            { 

                            <Checkbox className={"ch-fourth"} checked={!!cFound} sx={{p:0}}  onClick={() => storeActions.toggleKnlgToElm(elm)}    />
                            }
                          </Grid>
                          <Grid item xs className="d-f elm-tick auto " sx={{flexDirection:'column', paddingTop: '8px'}}>
                            
                            <div >
                              <Typography variant="span" sx={{fontSize: 14}} className={"  font-2 fourth-color cap" }>
                                {elm.title}
                              </Typography>
                              
                            </div>
                            
                          </Grid>
                        </Grid>

                        <Divider light className="w-100"/>
                      </Box>
                      )
                  }
                ))}
              </Grid>
            </SimpleBar>
          </>
        }
      </Grid> 

    </Box>
    );
}